import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWalletMenuBulk = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.4 11.255a3.29 3.29 0 0 1 3.28-3.29h4.008a.29.29 0 0 0 .292-.302c-.176-2.84-2.541-5.099-5.42-5.099H8.43c-3 0-5.44 2.44-5.44 5.44v3.306c0 .218.226.365.434.299a4.3 4.3 0 0 1 1.286-.194h3.43c2.29 0 3.95 1.7 3.95 4.04v3.18q0 .604-.135 1.14c-.05.202.095.41.303.41h4.302c3.02 0 5.276-2.45 5.423-5.35a.29.29 0 0 0-.293-.3h-4.01c-1.8 0-3.28-1.47-3.28-3.28"
      clipRule="evenodd"
      opacity={0.4}
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.53 11.195a.749.749 0 1 1-1.5 0c0-.42.33-.75.75-.75.41 0 .75.33.75.75m-2.63.06c0 .98.8 1.78 1.78 1.78h4.01a.3.3 0 0 0 .3-.3v-2.97a.3.3 0 0 0-.3-.3h-4.01c-.98 0-1.78.8-1.78 1.79M9.335 16.305H7.172v-2.14h.967c.749 0 1.196.483 1.196 1.29zm0 2.33c0 .815-.447 1.3-1.196 1.3h-.967v-2.13h2.163zm-3.663-2.33H3.51v-.85c0-.807.447-1.29 1.196-1.29h.966zm0 3.63h-.966c-.75 0-1.196-.485-1.196-1.3v-.83h2.162zm2.467-7.27H4.706c-1.588 0-2.696 1.148-2.696 2.79v3.18c0 1.649 1.108 2.8 2.696 2.8h3.433c1.588 0 2.696-1.151 2.696-2.8v-3.18c0-1.642-1.108-2.79-2.696-2.79"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgWalletMenuBulk);
export default ForwardRef;
